"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupSignup = void 0;
const modal_1 = require("../../components/modal/modal");
const popup_storage_1 = require("./popup-storage");
const types_1 = require("./types");
const condition_runtime_1 = require("./condition-runtime");
const utils_1 = require("./utils");
const constants_1 = require("./constants");
const check_media_1 = require("../../utils/check-media");
const utils_2 = require("../../utils/utils");
const BODY_ELEMENT_SELECTOR = 'body-element';
class PopupSignup extends modal_1.ModalComponent {
    storage;
    conditionRuntime;
    variant;
    hasImage;
    hideImgOnMobile;
    isSuccessMessage = false;
    constructor() {
        super();
        this.storage = new popup_storage_1.PopupStorage(this.dataset.blockId ?? this.id);
        this.variant = this.dataset.variant;
        this.hasImage = this.dataset.hasImage === 'true';
        this.hideImgOnMobile = this.dataset.hideImgMobile === 'true';
    }
    mountComponent() {
        if (this.isEditor) {
            this.editor.on('BLOCK_SELECT', this._handleBlockSelect);
            this.editor.on('BLOCK_DESELECT', this._handleBlockDeselect);
            return;
        }
        const data = this.storage.loadData();
        // don't show on captcha page
        if (window.location.pathname.includes('challenge')) {
            return;
        }
        // handle success message
        if (this.dataset.showSuccessMessage === 'true' &&
            window.sessionStorage.getItem('customer-posted-block-id') ===
                this.dataset.blockId) {
            this.show();
            window.sessionStorage.removeItem('customer-posted-block-id');
            this.classList.add(constants_1.POPUP_CLASSNAMES.success);
            this.isSuccessMessage = true;
            return;
        }
        if (!data || data.type === types_1.PopupType.Signup) {
            if (data?.lastShow) {
                try {
                    data.lastShow = new Date(data.lastShow);
                }
                catch {
                    data.lastShow = null;
                }
            }
            this.conditionRuntime = new condition_runtime_1.ConditionRuntime(this.dataset, data?.lastShow ?? null, this.show);
            this.conditionRuntime.run();
        }
    }
    unmountComponent() {
        this.conditionRuntime?.cleanup();
    }
    _handleBlockSelect = ({ detail: { blockId } }) => {
        if (this.dataset.blockId === blockId) {
            this.show();
        }
    };
    _handleBlockDeselect = ({ detail: { blockId } }) => {
        if (this.dataset.blockId === blockId) {
            this.hide();
        }
    };
    show = async () => {
        if (this.variant === 'lightbox') {
            const withGradient = !!this.dataset.overlayGradient;
            const bodyElement = (0, utils_2.$el)(BODY_ELEMENT_SELECTOR);
            const background = withGradient
                ? (0, utils_1.gradientOpacify)(this.dataset.overlayGradient, this.dataset.overlayOpacity)
                : `color-mix(in srgb, ${this.dataset.overlaySolid} ${Number(this.dataset.overlayOpacity) * 100}%, transparent)`;
            const blurFilter = `blur(${this.dataset.overlayBlur}px)`;
            (0, utils_2.whenDefined)('body-element').then(() => {
                bodyElement.showOverlay(this.id, {
                    zIndex: 8888,
                    background,
                    backdropFilter: blurFilter,
                    '-webkit-backdrop-filter': blurFilter,
                    transitionDuration: `${utils_1.POPUP_ANIMATION_DELAY}ms`,
                });
            });
        }
        await super.show();
        this.saveLastShowData();
        const closeBtn = this.selectBtn('close-small');
        const stickers = (0, utils_2.$list)('.lbc-sticker', this);
        if (closeBtn) {
            closeBtn.style.display = 'flex';
        }
        if (stickers) {
            setTimeout(() => {
                stickers.forEach(sticker => {
                    sticker.style.opacity = '1';
                });
            }, 1500);
        }
        this.addListener(this.selectBtn('close'), 'click', this.hide);
        this.addListener(this.selectBtn('close-small'), 'click', this.hide);
        this.addListener(this.selectBtn('submit'), 'click', this.onSubmit);
        if (this.variant === 'lightbox') {
            this.classList.add(constants_1.POPUP_CLASSNAMES.lightboxActive);
        }
        if (this.hasImage) {
            if (this.hideImgOnMobile && (0, check_media_1.isMobile)()) {
                return;
            }
            if (this.isSuccessMessage) {
                return;
            }
            setTimeout(() => {
                this.classList.add(constants_1.POPUP_CLASSNAMES.showImage);
            }, utils_1.POPUP_ANIMATION_DELAY);
        }
    };
    hide = async () => {
        this.saveLastShowData();
        if (this.variant === 'lightbox') {
            const bodyElement = (0, utils_2.$el)(BODY_ELEMENT_SELECTOR);
            (0, utils_2.whenDefined)('body-element').then(() => {
                bodyElement.hideOverlay(this.id);
            });
        }
        this.conditionRuntime?.cleanup();
        this.removeListener(this.selectBtn('close'), 'click', this.hide);
        this.removeListener(this.selectBtn('close-small'), 'click', this.hide);
        this.removeListener(this.selectBtn('submit'), 'click', this.onSubmit);
        if (this.variant === 'lightbox') {
            this.classList.remove(constants_1.POPUP_CLASSNAMES.lightboxActive);
            this.classList.add(constants_1.POPUP_CLASSNAMES.lightboxClosing);
        }
        await super.hide();
        this.classList.remove(constants_1.POPUP_CLASSNAMES.showImage);
        this.classList.remove(constants_1.POPUP_CLASSNAMES.lightboxClosing);
    };
    onSubmit = () => {
        // for success page detection
        window.sessionStorage.setItem('customer-posted-block-id', this.dataset.blockId);
    };
    saveLastShowData = () => {
        this.storage.saveData({
            type: types_1.PopupType.Signup,
            lastShow: new Date(),
        });
    };
    selectBtn(type) {
        if (!this.isOpen) {
            return null;
        }
        return (0, utils_2.$el)(`[data-${type}-btn]`, this);
    }
}
exports.PopupSignup = PopupSignup;
